/**
 * Returns true if `username` is allowed to approve/revoke connectors.
 *
 * Configured via VITE_APPROVAL_USERS env var — comma-separated list of
 * usernames, e.g. "admin,john,maria".
 *
 * If the variable is empty or not set, ALL users are allowed (open mode).
 */
export function canApprove(username) {
  const raw = import.meta.env.VITE_APPROVAL_USERS || ''
  const list = raw.split(',').map((u) => u.trim()).filter(Boolean)
  if (list.length === 0) return true
  return list.includes(username)
}

/**
 * Returns true if `username` is allowed to delete connectors.
 *
 * Configured via VITE_DELETE_USERS env var — comma-separated list of
 * usernames, e.g. "admin,devlead".
 *
 * If the variable is empty or not set, ALL users are allowed (open mode).
 */
export function canDelete(username) {
  const raw = import.meta.env.VITE_DELETE_USERS || ''
  const list = raw.split(',').map((u) => u.trim()).filter(Boolean)
  if (list.length === 0) return true
  return list.includes(username)
}
